// extracted by mini-css-extract-plugin
module.exports = {"limit-count":"LimitedTextarea_limit-count__nb2QO","limit-count-warning":"LimitedTextarea_limit-count-warning__LyW0i"};